


























































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_funciones from '@/mixins/axios/poa_funciones'
//@ts-ignore
import poa_subfunciones from '@/mixins/axios/poa_subfunciones'

//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
            
          
            {
                tag:'clave',
                data:'clave',
                active:true
            },
            {
                tag:'nombre_catalogo',
                data:'nombre_catalogo',
                active:true
            },
               /*{
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },*/
            
           
        ],



        id:null as any,
        nombre_catalogo:null as any,
clave:null as any,
      idfunciones:0,
     
            idfinalidades:null as any,
         
         
              poa_Subfuncionesdata:[] as any,
              poa_funciones:[]as any,
          
      
    }
  },
     mixins: [poa_funciones,poa_subfunciones],
     validations: {
    
           clave: {
      required,
    },
 
     
           nombre_catalogo: {
      required,
    },
 
         
 
 
  },
  methods:{
      onChangeF(event){
//console.log(event.target.value)
this.getDataFunciones(event.target.value);

},
       async getDataFunciones(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_POA_FUNCIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_funciones=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_SUBFUNCIONES(row).then(response => {

                    if (response != null) {

 this.poa_Subfuncionesdata=this.poa_Subfuncionesdata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },

     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                
                 this.clave=null;
                  this.nombre_catalogo=null;
              
                 

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_funciones_data').modal('show')
      },
seteditar(row){


 this.id=row.id;

                 this.clave=row.clave;
                  this.nombre_catalogo=row.nombre_catalogo;
                 
                 

            
          
 $('#ac_modal_funciones_data').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_SUBFUNCIONES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_Subfuncionesdata.push(response)

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador areas, refresque la pagina");

                    }    $("#ac_modal_funciones_data").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){

let data= await this.EDITAR_POA_SUBFUNCIONES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador Variable modificado exitosamente, refresque la pagina");
  this.poa_Subfuncionesdata=this.poa_Subfuncionesdata.filter(item => item.id !== dat.id);
 this.poa_Subfuncionesdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Variables, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
            idfinalidades:this.$store.state.finalidad_sel.id,
           idfunciones:this.$store.state.funciones_sel.id,
                 clave:this.clave,
                nombre_catalogo:this.nombre_catalogo,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true); 
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio,
idfunciones:this.$store.state.funciones_sel.id,
 idfinalidades:this.$store.state.finalidad_sel.id,
};

let data= await this.GET_POA_SUBFUNCIONES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_Subfuncionesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
    this.getData();
    this.getDataFunciones();
    
      //alert('10')
  }
})
export default class Home extends Vue {}

